export const typography = {  
  fontSizes: {
    '4xs': '0.125rem', // 2
    '3xs': '0.25rem', // 4
    '2xs': '0.5rem', // 8
    xs: "0.75rem", // 12
    sm: "0.875rem", // 14
    md: "1rem", // 16
    lg: "1.125rem", // 18
    xl: "1.25rem", // 20
    "2xl": "1.5rem", // 24
    "3xl": "1.75rem", // 28
    "4xl": "2rem", // 32
    "5xl": "2.5rem", // 40
    "6xl": "3rem", // 48
    "7xl": "3.5rem", // 56
    "8xl": "4rem", // 64
    "9xl": "4.5rem", // 72
    "10xl": "5rem", // 80
    "11xl": "6rem", // 96
    "12xl": "8rem", // 128
    "13xl": "10rem", // 160
    "14xl": "14rem", // 196
    "16xl": "16rem", // 256
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
  },
  fonts: {
    heading: `poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`,
  },
}